import {createSelector} from "reselect";
import {getAdminStoreState} from "../../store/admin-store-selectors";

export class ApplicationAdminSharedStoreSelectors {
    static readonly state = createSelector(getAdminStoreState, state => state.shared);
}
